import styled from '@emotion/styled';
import { GameDetailsTeam } from 'modules/games/domain/interfaces/game-details';
import UDFormInput from 'ud-form/components/input';
import { UDInputProps } from 'ud-form/components/input/component';
import { UDFormComponentProps } from 'ud-form/components/types';
import TeamLogo from 'ud-ui/components/team-logo';
import UDText from 'ud-ui/components/text';
import { theme } from 'styles/theme/theme';

const TeamScoreCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${theme.colors.SurfaceWhite};
  border-radius: 8px;
  padding: 8px 16px 8px 8px;
  margin-top: 16px;
`;

const TeamInfoWrapper = styled.div`
  display: flex;
  align-items: center;

  .team-logo {
    margin-right: 8px;
  }
`;

const TeamScoreInputWrapper = styled.div`
  width: 120px;

  .team-score-input {
    background: ${theme.colors.SurfaceCultured10};
  }
`;

type TeamScoreCardProps = { team: GameDetailsTeam } & UDFormComponentProps & Omit<UDInputProps, 'hasError' | 'valid' | 'ref'>;

export const TeamScoreCard = (props: TeamScoreCardProps) => {
  const { team, ...otherProps } = props;

  return (
    <TeamScoreCardContainer>
      <TeamInfoWrapper>
        <TeamLogo className="team-logo ml-2" url={team.logo} />
        <UDText type="subhead">{team.name}</UDText>
      </TeamInfoWrapper>
      <TeamScoreInputWrapper>
        <UDFormInput className="team-score-input" type="number" min={0} {...otherProps} />
      </TeamScoreInputWrapper>
    </TeamScoreCardContainer>
  );
};
